<div class="modal-header">
    <h5 class="modal-title">Angiv fravær</h5>
    <button type="button" data-bs-theme="dark" class="btn-close" (click)="cancel()"></button>
</div>

<div class="modal-body">

    <div class="form-group">
        <label>Fraværstype</label>
        <select [(ngModel)]="selectedType" class="form-select fravaer-type-select">
            <option *ngFor="let type of fravaerTypes" [value]="type" [class]="getOptionClass(type)">
                {{ type }}
            </option>
        </select>
    </div>

    <div class="form-group">
        <label>Periode</label>
    </div>
    <app-medarbejdere-range-picker
        [activeYear]="activeYear"
        [range]="dateRange"
        (rangeChange)="dateRange = $event"
        [placement]="'bottom-left'">
    </app-medarbejdere-range-picker>

</div>

<div class="modal-footer">
    <button class="btn btn-secondary btn-sm" (click)="cancel()">Annuller</button>
    <button class="btn btn-primary btn-sm" (click)="save()" [disabled]="!isValid()">Gem</button>
</div>
